import React from 'react';
import AssetWrapper, { AssetWrapperProps } from 'src/app/atoms/Asset/AssetWrapper';
import Stack from 'src/app/atoms/Layout/Stack/Stack';

const Avatar = (props: AssetWrapperProps): JSX.Element => {
  return (
    <Stack
      border='1px solid var(--border-primary)'
      borderRadius='radius-circle'
      overflow='hidden'
    >
      <AssetWrapper {...props} />
    </Stack>
  );
};

export default Avatar;
